import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ValueAddedOP, TechnicalProductsResponseOP } from '@cemex-core/cmx-api';
import * as fromAddedValuesOpenPlatformActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/added-values.op.actions';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import * as fromProductsOpenPlatformActions from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/products.op.actions';

export const adapter: EntityAdapter<ValueAddedOP> = createEntityAdapter<ValueAddedOP>({
  selectId: (_addedValue: ValueAddedOP) => _addedValue.valueAddedCode,
  sortComparer: false,
});

interface AdapterState extends EntityState<ValueAddedOP> {
  selectedAddedValueCode: string | null;
}

export interface State {
  mandatoryAddedValues: EntityState<ValueAddedOP>;
  firstGroup: AdapterState;
  secondGroup: AdapterState;
  thirdGroup: AdapterState;
  fourthGroup: AdapterState;
}

const initialState: State = {
  mandatoryAddedValues: adapter.getInitialState(),
  firstGroup: adapter.getInitialState({ selectedAddedValueCode: null }),
  secondGroup: adapter.getInitialState({ selectedAddedValueCode: null }),
  thirdGroup: adapter.getInitialState({ selectedAddedValueCode: null }),
  fourthGroup: adapter.getInitialState({ selectedAddedValueCode: null }),
};

export function reducer(
  state = initialState,
  action: fromAddedValuesOpenPlatformActions.Actions | OrderBuilderActions,
): State {
  switch (action.type) {
    case fromAddedValuesOpenPlatformActions.ActionTypes.ADD_MANDATORIES: {
      const payload: ValueAddedOP[] = action.payload;
      return {
        ...state,
        mandatoryAddedValues: adapter.addMany(payload, state.mandatoryAddedValues),
        firstGroup: adapter.removeAll({ ...state.firstGroup, selectedAddedValueCode: null }),
        secondGroup: adapter.removeAll({ ...state.secondGroup, selectedAddedValueCode: null }),
        thirdGroup: adapter.removeAll({ ...state.thirdGroup, selectedAddedValueCode: null }),
        fourthGroup: adapter.removeAll({ ...state.fourthGroup, selectedAddedValueCode: null }),
      };
    }
    case fromAddedValuesOpenPlatformActions.ActionTypes.FETCH_FIRST_GROUP_SUCCESS: {
      const payload: TechnicalProductsResponseOP = action.payload;
      return {
        ...state,
        firstGroup: adapter.addMany(
          payload.valueAddeds,
          adapter.removeAll({ ...state.firstGroup, selectedAddedValueCode: null }),
        ),
      };
    }
    case fromAddedValuesOpenPlatformActions.ActionTypes.FETCH_SECOND_GROUP_SUCCESS: {
      const payload: TechnicalProductsResponseOP = action.payload;
      return {
        ...state,
        secondGroup: adapter.addMany(payload.valueAddeds, state.secondGroup),
      };
    }
    case fromAddedValuesOpenPlatformActions.ActionTypes.FETCH_THIRD_GROUP_SUCCESS: {
      const payload: TechnicalProductsResponseOP = action.payload;
      return {
        ...state,
        thirdGroup: adapter.addMany(payload.valueAddeds, state.thirdGroup),
      };
    }
    case fromAddedValuesOpenPlatformActions.ActionTypes.FETCH_FOURTH_GROUP_SUCCESS: {
      const payload: TechnicalProductsResponseOP = action.payload;
      return {
        ...state,
        fourthGroup: adapter.addMany(payload.valueAddeds, state.fourthGroup),
      };
    }
    case fromAddedValuesOpenPlatformActions.ActionTypes.SELECT: {
      const payload: { group: number; code: string } = action.payload;
      switch (payload.group) {
        case 0:
          state.firstGroup.selectedAddedValueCode = payload.code;
          return {
            ...state,
            secondGroup: adapter.removeAll({ ...state.secondGroup, selectedAddedValueCode: null }),
            thirdGroup: adapter.removeAll({ ...state.thirdGroup, selectedAddedValueCode: null }),
            fourthGroup: adapter.removeAll({ ...state.fourthGroup, selectedAddedValueCode: null }),
          };
        case 1:
          state.secondGroup.selectedAddedValueCode = payload.code;
          return {
            ...state,
            thirdGroup: adapter.removeAll({ ...state.thirdGroup, selectedAddedValueCode: null }),
            fourthGroup: adapter.removeAll({ ...state.fourthGroup, selectedAddedValueCode: null }),
          };
        case 2:
          state.thirdGroup.selectedAddedValueCode = payload.code;
          return {
            ...state,
            fourthGroup: adapter.removeAll({ ...state.fourthGroup, selectedAddedValueCode: null }),
          };
        case 3:
          state.fourthGroup.selectedAddedValueCode = payload.code;
          return {
            ...state,
          };
        default:
          return state;
      }
    }
    case RESET_BUILDER:
    case fromProductsOpenPlatformActions.ActionTypes.RESET:
    case fromAddedValuesOpenPlatformActions.ActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case fromAddedValuesOpenPlatformActions.ActionTypes.FETCH:
    case fromAddedValuesOpenPlatformActions.ActionTypes.FETCH_FAILURE:
    default:
      return state;
  }
}
